/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
// import React, { useState } from "react";
// import { useSelector } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../../components/CustomInput";
import CustomSelect from "../../../../components/CustomSelect";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CustomTextArea from "../../../../components/CustomTextArea";
import { func, object } from "prop-types";

import icons from "../../../../assets/icons/icon-collection.svg";
// import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import SearchLocationInput from "../../../../components/LocationComponent";
import {
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { Tooltip } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import {
  createCategorySkillAction,
} from "../../../../redux/actions/skillsAction";
import { invalidateAllSkillsQuery } from "../../../../hooks/queries";

const JobDetails = ({
  setNewJob,
  newJob,
  handleChange,
  industryOptions,
  levelOptions,
  skillOptions,
  subsidiaryOptions,
  departmentOptions,
}) => {
  const [selectedSkills, setSelectedSkills] = useState([]);
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  // const { userData } = useSelector(({ auth }) => auth);
  // const [location, setLocation] = useState({
  //   location: userData.location || "",
  //   coordinate: "",
  // });

  // console.log("subs", subsidiaryOptions);

  const addSkill = ({ target: { value } }) => {
    const skills = value;
    setSelectedSkills(skills);
    handleChange({ target: { value: skills, name: "skills_required" } });
  };

const [inputValue, setInputValue] = useState("");

const handleSkillsChange = (_event, value, reason) => {
  // Prevent clearing all skills when clicking the X button
  if (reason === 'clear') {
    setInputValue("");
    return;
  }
  
  const normalized = value.map((v) =>
    typeof v === "string" ? v : v?.inputValue ? v.inputValue : v?.title || v
  );
  setSelectedSkills(normalized);
  setInputValue("");
  handleChange({ target: { value: normalized, name: "skills_required" } });
  const existingTitles = new Set(
    (skillOptions || []).map(({ title }) => (title || "").toLowerCase())
  );
  const newTitles = normalized
    .map((t) => (t || "").trim())
    .filter((t) => t && !existingTitles.has(t.toLowerCase()));
  if (newTitles.length > 0) {
    Promise.all(
      newTitles.map((title) =>
        createCategorySkillAction({ title, description: title }, dispatch)
      )
    ).then(() => invalidateAllSkillsQuery(queryClient));
  }
};

  const handleLocationChange = (place) => {
    // console.log("hello...");
    handleChange({ target: { value: place, name: "location" } });
    // setLocation({ coordinate: "", location: place });
  };
  const displaySkills = () => {
    return selectedSkills.map((skill, index) => (
      <span
        className="d-flex align-items-center justify-content-between mt-2 mr-2 py-1 pl-3 outlined"
        key={index.toString()}
      >
        {skill}
        <IconButton onClick={() => removeSkill(skill)}>
          <svg width="10" height="8">
            <use href={`${icons}#close-blue`}></use>
          </svg>
        </IconButton>
      </span>
    ));
  };
  const removeSkill = (skillToRemove) => {
    const skillArray = [...selectedSkills];
    const newSkillArray = skillArray.filter((skill) => skill !== skillToRemove);
    setSelectedSkills(newSkillArray);
    handleChange({ target: { value: newSkillArray, name: "skills_required" } });
  };

  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "1rem",
        }}
      >
        {/* <SearchLocationInput handleLocationChange={handleLocationChange} /> */}
        <CustomSelect
          handleChange={handleChange}
          options={{ 0: "Select Subsidiary", ...subsidiaryOptions }}
          id="subsidiary_id"
          name="subsidiary_id"
          label="Subsidiaries"
          currentValue={newJob.subsidiary_id}
        />
        <CustomInput
          type="text"
          onChange={handleChange}
          name="role_title"
          value={newJob.role_title}
          label="Role title"
          id="role"
        />
        <SearchLocationInput
          inputStyle="TextField"
          handleLocationChange={handleLocationChange}
        />

        {/* <CustomInput
        type="text"
        onChange={handleChange}
        name="location"
        value={newJob.location}
        label="Location"
        id="location"
      /> */}
        <CustomInput
          type="text"
          onChange={handleChange}
          name="reports_to"
          value={newJob.reports_to}
          label="Reports To"
          id="report"
        />
        <CustomSelect
          handleChange={handleChange}
          options={{ 0: "Select Level", ...levelOptions }}
          id="level"
          name="job_level"
          label="Job Level"
          currentValue={newJob.job_level}
        />
        <CustomSelect
          handleChange={handleChange}
          options={{
            0: "Select Type",
            "part-time": "Part-time",
            "full-time": "Full-time",
            contract: "Contract",
            internship: "Internship",
            volunteer: "Volunteer",
          }}
          id="job_type"
          name="job_type"
          label="Type of Employment"
          currentValue={newJob.job_type}
        />
        <CustomSelect
          handleChange={handleChange}
          options={{ 0: "Select an Industry", ...industryOptions }}
          id="industry"
          name="industry"
          label="Industry"
          currentValue={newJob.industry}
        />
        <CustomSelect
          handleChange={handleChange}
          id="department"
          name="department"
          label="Department"
          // value={state.department}
          options={departmentOptions}
          currentValue={newJob.department}
        />

        {/* <CustomTextArea
        onChange={handleChange}
        name="about_role"
        value={newJob.about_role}
          label="About Company/Role"
           style={{ gridColumn: "span 2" }}
        id="about_role"
      /> */}
        {/* <CustomSelect
        name="skills_required"
        handleChange={handleChange}
        options={skillOptions}
        id="skills"
        label="Skills"
        currentValue={newJob.skills_required}
        multiple
      /> */}

        <FormControl
          variant="standard"
          className="custom-input w-25 w-100 mt-3"
          style={{ gridColumn: "span 2" }}
        >
          <label className="d-block mb-0">Skills</label>
          <Autocomplete
            multiple
            freeSolo
            disableClearable
            clearIcon={null}
            popupIcon={null}
            id="skills"
            options={(skillOptions || []).map(({ title }) => title)}
            value={selectedSkills}
            inputValue={inputValue}
            onInputChange={(event, newInputValue, reason) => {
              if (reason !== "reset") {
                setInputValue(newInputValue);
              }
            }}
            onChange={handleSkillsChange}
            filterSelectedOptions
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            filterOptions={(options, params) => {
              const filter = createFilterOptions();
              return filter(options, params);
            }}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option?.title || ""
            }
            renderOption={(option) =>
              typeof option === "string" ? option : option?.title || ""
            }
            renderInput={(params) => {
              const { InputProps, inputProps } = params;
              return (
                <div className="custom-text-field mt-2 w-100">
                  <div className="input-wrapper">
                    <input
                      {...inputProps}
                      ref={InputProps.ref}
                      className={`w-100 ${inputProps.className || ""}`}
                      placeholder="Add Skill (ex: Interior Design)"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          e.stopPropagation();
                        }
                      }}
                    />
                  </div>
                </div>
              );
            }}
          />
          <div className="skills-count mt-3 w-100 d-flex align-items-center">
            <span className="blob rounded px-2 py-1 bg-green co-white">
              <b>{selectedSkills.length}</b>
            </span>
            <span className="ml-2 co-green medium-text">Skills count</span>
          </div>
          {selectedSkills[0] && (
            <div className="mt-5 w-100 d-flex flex-wrap">{displaySkills()}</div>
          )}
        </FormControl>

        {/* <RadioGroup
        className="mt-2"
        name="isCompanyRepresentative"
        value={newJob.isCompanyRepresentative}
        onChange={handleChange}
      >
        <label>Are you a company representative?</label>
        <div className="d-flex">
          <FormControlLabel
            onChange={handleChange}
            value="1"
            control={<Radio color="primary" />}
            label="Yes"
          />
          <FormControlLabel
            onChange={handleChange}
            value="0"
            control={<Radio color="primary" />}
            label="No"
          />
        </div>
      </RadioGroup> */}
      </div>
      
      {/* About Hiring Manager Section */}
      <div className="mt-4">
        <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
          <label style={{ fontWeight: "500", margin: 0 }}>
            About Hiring Manager
          </label>
          <Link
            to="/settings/help"
            style={{
              textDecoration: "none",
              color: "#6c757d",
              marginLeft: "6px",
              display: "inline-block",
            }}
            title="Learn more about why this field matters"
          >
            <HelpOutlineIcon
              style={{
                fontSize: "18px",
                cursor: "pointer",
              }}
            />
          </Link>
        </div>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          name="about_hiring_manager"
          value={newJob.about_hiring_manager || ""}
          onChange={handleChange}
          placeholder="A short note about the hiring manager builds trust and attracts better aligned candidates by showing who leads the role."
          helperText={`${(newJob.about_hiring_manager || "").length}/700 characters (optional)`}
          inputProps={{ maxLength: 700 }}
          style={{ marginBottom: "16px" }}
        />
      </div>

      <label className="mt-4" htmlFor="">
        About Company/Role
      </label>
      <CKEditor
        className="pt-4 mt-2"
        editor={ClassicEditor}
        data={newJob.about_role}
        config={{
          toolbar: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "bulletedList",
            "numberedList",
            "blockQuote",
          ],
        }}
        onReady={(editor) => {
          console.log("Editor is ready to use!", editor);
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          setNewJob({ ...newJob, about_role: data });
        }}
        onBlur={(event, editor) => {
          console.log("Blur event", editor);
        }}
        onFocus={(event, editor) => {
          console.log("Focus event", editor);
        }}
      />
    </>
  );
};

JobDetails.propTypes = {
  newJob: object.isRequired,
  setSelectedSkills: func.isRequired,
  handleChange: func.isRequired,
  industryOptions: object.isRequired,
  levelOptions: object.isRequired,
  skillOptions: object.isRequired,
};

export default JobDetails;
